import * as React from "react";
const SvgFiRr9 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19.992 7.871C19.806 3.626 16.531.206 12.386.01a7.99 7.99 0 0 0-5.806 2.105 7.93 7.93 0 0 0-2.576 5.602c-.073 2.101.738 4.204 2.227 5.77 1.508 1.585 3.51 2.478 5.639 2.512A8.07 8.07 0 0 0 18 13.291V14c0 4.411-3.59 8-8 8H7a1 1 0 1 0 0 2h3c5.514 0 10-4.486 10-10 0 0-.004-6.087-.009-6.129zm-7.993 6.13a6 6 0 1 1 0-12 6 6 0 1 1 0 12"
    />
  </svg>
);
export default SvgFiRr9;
